import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar.jsx';
import Header from './Header.jsx';
import { LeadsDataProvider } from '../modules/leads/hooks/useLeadsData.jsx';
import AnalyticsAssistant from '../shared/components/AnalyticsAssistant.jsx';

export default function AnalyticsLayout({ email }) {
  return (
    <LeadsDataProvider email={email}>
      <div className="analytics-platform">
        <Sidebar />
        <div className="analytics-platform-main">
          <Header email={email} />
          <div className="analytics-platform-content">
            <Outlet context={{ email }} />
          </div>
        </div>
        <AnalyticsAssistant />
      </div>
    </LeadsDataProvider>
  );
}
